import { ChangeEvent, useCallback } from 'react';

import { Input } from '@pukka/ui-components';
import { FaSearch } from 'react-icons/fa';
import { twMerge } from 'tailwind-merge';

interface SearchBarProps {
  readonly onKeywordChange: (keyword: string) => void;
  readonly placeholder: string;
  readonly defaultValue?: string;
  readonly className?: string;
}

function SearchBar({ onKeywordChange, placeholder, defaultValue, className }: SearchBarProps) {
  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onKeywordChange(e.target.value);
    },
    [onKeywordChange],
  );

  return (
    <div className={twMerge('relative flex items-center', className)}>
      <FaSearch className="absolute right-4 text-neutral-400" size={12} />
      <Input inputClassName="pr-8" placeholder={placeholder} defaultValue={defaultValue} onChange={onChange} />
    </div>
  );
}

export { SearchBar };
